import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  patchDigestPreferenceStep,
  patchDigestSportVisibility,
  type PatchDigestSportVisibilityInput,
  type PatchDigestStepInput,
} from '@nomiss/services';
import { digestQueryKeys } from './use-digest-feed';
import { digestPreferencesEditorQueryKeys } from './use-digest-preferences-editor';
import { manageDigestQueryKeys } from './use-manage-digest';
import { subscriptionQueryKeys } from './use-subscription';

function invalidateManageDigestQueries(queryClient: ReturnType<typeof useQueryClient>) {
  void queryClient.invalidateQueries({
    queryKey: manageDigestQueryKeys.preferences,
  });
  void queryClient.invalidateQueries({
    queryKey: digestPreferencesEditorQueryKeys.editor,
  });
  void queryClient.invalidateQueries({
    queryKey: subscriptionQueryKeys.me,
  });
  void queryClient.invalidateQueries({
    queryKey: subscriptionQueryKeys.sports,
  });
  void queryClient.invalidateQueries({ queryKey: digestQueryKeys.all });
}

export function usePatchDigestPreferenceStep() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: {
      sportCode: string;
      stepId: string;
      body: PatchDigestStepInput;
    }) =>
      patchDigestPreferenceStep(input.sportCode, input.stepId, input.body),
    onSuccess: () => {
      invalidateManageDigestQueries(queryClient);
    },
  });
}

export function usePatchDigestSportVisibility() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: {
      sportCode: string;
      body: PatchDigestSportVisibilityInput;
    }) => patchDigestSportVisibility(input.sportCode, input.body),
    onSuccess: () => {
      invalidateManageDigestQueries(queryClient);
    },
  });
}
